import HeyGame from '@/models/heyGame.ts'

export interface AlbumPreviewFile {
  id: string
  file: string
  detail: string | null
  thumbnail: string | null
  file_type: 'img' | 'vid'
  width: number | null
  height: number | null
}

export interface Album {
  id: string
  author: string
  title: string
  description: string
  thumbnail: string | null
  preview_desktop: AlbumPreviewFile | null
  preview_desktop_center_x: number
  preview_desktop_center_y: number
  preview_mobile: AlbumPreviewFile | null
  preview_mobile_center_x: number
  preview_mobile_center_y: number
  is_primary: boolean
  is_private: boolean
  is_upload_disabled: boolean
  is_unlisted: boolean
  is_games_disabled: boolean
  drive: string
  games: Array<HeyGame>
  qr_code_image: string | null
  is_max_media_per_guest: boolean
  is_max_media_also_game: boolean
  max_media_per_guest: number
  is_guestbook_private: boolean
  is_guestbook_disabled: boolean
  is_guestbook_upload_disabled: boolean
  default_files_order: '' | 'created-at' | '-created-at' | 'file-creation' | '-file-creation'
}

/** Get the thumbnail URL from an album list: primary album first, then any album with a thumbnail. */
export function getThumbnailFromAlbums(albums: Array<{ is_primary?: boolean; thumbnail: string | null }>): string | null {
  const primary = albums.find(a => a.is_primary)
  if (primary?.thumbnail) return primary.thumbnail
  return albums.find(a => a.thumbnail)?.thumbnail ?? null
}
